import { useGetApiClient } from '../../../context/apiContext';
import { fetchHotelData, pickKeysFromHotel } from '../utils';
import { RequestState, useRequestState } from '../../../hooks/useRequestState';

export const useGetHotelData = () => {
  const api = useGetApiClient();
  const { setRequestState } = useRequestState();

  if (!api) {
    console.log('Не найден ключ партнёра');
    return;
  }

  const getHotelData = async (hotelId: number) => {
    setRequestState(RequestState.LOADING);

    try {
      const response = await fetchHotelData(api, hotelId);

      if (!response) {
        setRequestState(RequestState.ERROR);
        return;
      }

      const hotelData = pickKeysFromHotel(response.hotels[0]);

      setRequestState(RequestState.SUCCESS);
      return hotelData;
    } catch (err) {
      console.log('Error', err);
      setRequestState(RequestState.ERROR);
      return;
    }
  };

  return getHotelData;
};
